import { returnNonNull } from 'src/common/helpers/ArraysHelper';
import { formatDate } from 'src/common/helpers/DateFormatHelper';

import { MobileSdkIssueQuery } from '../MobileSdkIssue.generated';

export interface IMobileSdkIssueData {
	testName: string;
	runTime: string;
	scanName: string;
	shortNodeId: string;
}

export const transformMobileSdkIssueResults = (
	result: MobileSdkIssueQuery
): IMobileSdkIssueData | null => {
	const issues = result.issues?.filter(returnNonNull);

	if (!issues?.length) {
		return null;
	}

	const testRuns = result.msdk_test_runs?.filter(returnNonNull);
	const testRun = testRuns?.[0];
	const issue = issues[0];

	return {
		testName: testRun?.test_name ?? '',
		runTime: formatDate(issue.run_time) ?? '',
		scanName: issue.scan_name ?? 'Scan 1',
		shortNodeId: issue.elements__index?.[0] ?? '1'
	};
};
